// vue components
import TravelTileItem from './vue/components/_travel-tile-item.vue';
import RequirementRating from './vue/components/_requirement-rating.vue';

Vue.component('travel-tile-item', TravelTileItem);
Vue.component('requirement-rating', RequirementRating);